import React, { useState } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import * as actions from '../../actions/userActionCreators';
import AutoSynchronizingRevenueInformation from '../AutoSynchronizingRevenueInformation/AutoSynchronizingRevenueInformation';

const UpdateActivityTypeMutation = gql`
  mutation pullRevenueInformationForUser {
    pullRevenueInformationForUser {
      id
      trailer_revenue
      direct_revenue
      transactional_revenue
      fee_based_revenue
      years_practicing
      number_of_clients
      annual_revenue
      recurring_revenue
      assets_under_management
      avg_client_age
    }
  }
`;

export const RjPullRevenueInformationButton = ({ user, userUpdate, currentUser, onDataUpdated }) => {
  const [ open, setOpen ] = useState(false);
  return (
    <Mutation mutation={UpdateActivityTypeMutation}>
      {mutate => (
        <center>
          <Button
            variant="contained"
            color="primary"
            style={{ backgroundColor: '#5489b6', color: '#fff' }}
            onClick={() => setOpen(!open)}>
            Pull Latest Raymond James Data
          </Button>
          <Dialog
            open={open}
            onClose={() => setOpen(!open)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                By clicking okay Practice Exchange will pull the most recent data from Raymond James and overwrite any
                revenue information that has been entered in your Practice Exchange profile. Do you wish to proceed?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpen(!open)} color="primary">
                Disagree
              </Button>
              <Button
                onClick={() => {
                  mutate().then(response => {
                    setOpen(!open);
                    
                    // Update the user data in Redux/state if needed
                    if (response.data && response.data.pullRevenueInformationForUser && userUpdate) {
                      userUpdate(response.data.pullRevenueInformationForUser);
                    }
                    
                    // Call the callback to update the parent component's form data
                    if (onDataUpdated && typeof onDataUpdated === 'function') {
                      onDataUpdated(response.data?.pullRevenueInformationForUser);
                    }
                    
                    // Stay on current step instead of reloading
                    console.log('Raymond James data sync completed successfully');
                  });
                }}
                color="primary"
                autoFocus>
                Agree
              </Button>
            </DialogActions>
          </Dialog>
          {currentUser.company.feature_types.includes('users_choice_update_production_data_automatically') && (
            <AutoSynchronizingRevenueInformation currentUser={currentUser} />
          )}
        </center>
      )}
    </Mutation>
  );
};

const mapStateToProps = state => ({
  user : state.user,
});

export default connect(mapStateToProps, actions)(RjPullRevenueInformationButton);
